import { isDate } from 'lodash'

/**
 * Duck typing check if a given value is a valid Date object.
 *
 * @param {Date} value - The value to be checked
 * @returns {boolean} Whether this is a valid date object or not
 */
export function isValidDateObject(value) {
    return !!value && isDate(value) && !isNaN(value.getTime())
}
